import React, { FC } from 'react';
import { IconType } from '@svg/index';
import { DEFAULT_ICON_PROPS } from '@svg/helpers';

export const LockIcon: FC<IconType> = (props) => {
  const { width, height, color, dataTestId } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  return (
    <svg
      data-test-id={dataTestId}
      width={width}
      height={height} 
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.6784 9.06543L4.31844 9.06543C3.53389 9.06543 2.89844 9.70088 2.89844 10.4854L2.89844 17.5854C2.89844 18.37 3.53389 19.0054 4.31844 19.0054L15.6784 19.0054C16.463 19.0054 17.0984 18.37 17.0984 17.5854V10.4854C17.0984 9.70088 16.463 9.06543 15.6784 9.06543ZM9.99844 15.4554C9.21389 15.4554 8.57844 14.82 8.57844 14.0354C8.57844 13.2509 9.21389 12.6154 9.99844 12.6154C10.783 12.6154 11.4184 13.2509 11.4184 14.0354C11.4184 14.82 10.783 15.4554 9.99844 15.4554Z"
        fill={color}
      />
      <path
        d="M14.2583 7.59505H12.8383L12.8383 6.17505C12.8546 4.62441 11.6121 3.35351 10.0615 3.33505H10.0317C8.47178 3.30807 7.18526 4.54986 7.15828 6.10973V6.11186L7.15828 7.59505H5.73828L5.73828 6.10405C5.76171 3.78661 7.64463 1.91931 9.96207 1.91505H10.0054C12.3498 1.91079 14.254 3.80791 14.2583 6.15233C14.2583 6.16227 14.2583 6.17221 14.2583 6.18215V7.59505Z"
        fill={color}
      />
    </svg>
  );
};
